import { downloadFile, downloadFromUrl, getResFilename, withLoading } from 'prace-common-components'
import { clientApi } from '..'

export const downloadsApi = clientApi.injectEndpoints({
  endpoints: (build) => ({
    downloadProposalFiles: build.query<void, number>({
      ...withLoading,
      query: (elementId) => ({
        url: `/cines/proposal/${elementId}`,
        responseHandler: async (res) =>
          res.status < 300 ? downloadFile(getResFilename(res), await res.blob()) : undefined,
        cache: 'no-cache',
      }),
    }),
    downloadAssignmentFiles: build.query<void, number>({
      ...withLoading,
      query: (assignmentId) => ({
        url: `/download/assignment/${assignmentId}`,
        responseHandler: async (res) =>
          res.status < 300 ? downloadFile(getResFilename(res), await res.blob()) : undefined,
        cache: 'no-cache',
      }),
    }),
    downloadPdf: build.query<void, string>({
      ...withLoading,
      query: (uid) => ({
        url: `/download/call/pdf/${uid}`,
        responseHandler: async (res) =>
          res.status < 300 ? downloadFile(getResFilename(res), await res.blob()) : undefined,
        cache: 'no-cache',
      }),
    }),
    downloadFile: build.query<void, { uid?: string; uploadId: number; elementName?: string}>({
      ...withLoading,
      query: ({ uid, uploadId, elementName }) => ({
        url: `/download/upload/${uploadId}`,
        responseHandler: async (res) =>
          res.status < 300 ? downloadFile(getResFilename(res), await res.blob(), uid, elementName) : undefined,
        cache: 'no-cache',
      }),
    }),
    downloadAllFiles: build.query<void, string>({
      ...withLoading,
      /* The API zips server-side and answers with a pre-signed URL; the browser downloads it in the
         background so the page never buffers the archive. */
      queryFn: async (uid, _api, _extraOptions, baseQuery) => {
        const result = await baseQuery(`/download/files/${uid}`)
        if (result.error) return { error: result.error }

        const { downloadUrl } = (result.data || {}) as { downloadUrl?: string }
        if (!downloadUrl) return { error: { status: 'CUSTOM_ERROR', error: 'Download URL missing' } }

        downloadFromUrl(downloadUrl)
        return { data: undefined }
      },
    }),
    downloadCallBundle: build.query<void, number>({
      ...withLoading,
      queryFn: async (callId, _api, _extraOptions, baseQuery) => {
        // Get a temporary signed download URL from the backend
        const result = await baseQuery(`/download/call/${callId}`)
        if (result.error) return { error: result.error }

        const data = result.data as { downloadUrl?: string; url?: string }
        const downloadUrl = data?.downloadUrl || data?.url
        if (downloadUrl) downloadFromUrl(downloadUrl)

        return { data: undefined }
      },
    }),
    downloadApplicationReport: build.query<void, { id: number; format: string }>({
      ...withLoading,
      query: ({ id, format }) => ({
        url: `/download/call/${id}/applications/${format}`,
        cache: 'no-cache',
      }),
    }),
  }),
})

export const {
  useLazyDownloadAssignmentFilesQuery,
  useLazyDownloadFileQuery,
  useLazyDownloadCallBundleQuery,
  useLazyDownloadPdfQuery,
  useLazyDownloadAllFilesQuery,
  useLazyDownloadProposalFilesQuery,
  useLazyDownloadApplicationReportQuery,
} = downloadsApi
